import { HttpParams } from "@angular/common/http";

export class HttpParamsEncoder {
  constructor(private httpParams?: HttpParams) {
    this.httpParams = httpParams ?? new HttpParams();
  }

  encode(params: any): HttpParams {
    if (params) {
      this.encodeParams(params, null);
    }

    return this.httpParams;
  }

  private encodeParams(params: any, prefix: string) {
    const str = [];
    let p;
    for (p in params) {
      if (params.hasOwnProperty(p)) {
        let k;
        let v;
        if (Array.isArray(params)) {
          k = prefix ? prefix + "[" + p + "]" : p;
          v = params[p] as any[];
        } else {
          k = prefix ? prefix + "." + p + "" : p;
          v = params[p] as any;
        }

        if (v !== null && typeof v === "object") {
          this.encodeParams(v, k);
        } else {
          this.httpParams = this.httpParams.set(k, v);
        }
      }
    }
  }
}


